package com.sweetlime.bingeamigo.presentation.features.search

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.sweetlime.bingeamigo.model.TvShow
import com.sweetlime.bingeamigo.repository.ReviewRepository
import com.sweetlime.bingeamigo.repository.TmdbRepository
import com.sweetlime.bingeamigo.state.TvShowState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class TvShowSearchViewModel(
    private val repository: TmdbRepository,
    private val reviewRepository: ReviewRepository,
) : ViewModel() {

    private val _shows = MutableStateFlow<TvShowState>(TvShowState.Idle)
    val shows: StateFlow<TvShowState> get() = _shows.asStateFlow()

    private val _query = MutableStateFlow("")
    val query: StateFlow<String> get() = _query.asStateFlow()

    private val _communityRatings = MutableStateFlow<Map<Int, Double>>(emptyMap())
    val communityRatings: StateFlow<Map<Int, Double>> = _communityRatings.asStateFlow()

    init {
        loadPopularTvShows()
    }

    fun onQueryChange(query: String) { _query.value = query }

    fun searchTvShows(query: String) {
        _shows.value = TvShowState.Loading
        viewModelScope.launch {
            try {
                val shows = repository.searchTvShows(query)
                _shows.value = TvShowState.Success(shows)
                fetchCommunityRatings(shows)
            } catch (e: Exception) {
                _shows.value = TvShowState.Error(e.message ?: "Unknown error")
            }
        }
    }

    fun loadPopularTvShows() {
        if (_shows.value is TvShowState.Success) return
        _shows.value = TvShowState.Loading
        viewModelScope.launch {
            try {
                val shows = repository.getPopularTvShows()
                _shows.value = TvShowState.Success(shows)
                fetchCommunityRatings(shows)
            } catch (e: Exception) {
                _shows.value = TvShowState.Error(e.message ?: "Unknown error")
            }
        }
    }

    private suspend fun fetchCommunityRatings(shows: List<TvShow>) {
        val docIds = shows.map { "SHOW_${it.id}" }
        val summaries = reviewRepository.getContentSummaries(docIds)
        _communityRatings.value = summaries.mapNotNull { (key, summary) ->
            if (summary.avgRating > 0.0) key.removePrefix("SHOW_").toIntOrNull()?.let { id -> id to summary.avgRating } else null
        }.toMap()
    }
}
